var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftmenu-toggle"},[_c('f7-button',{attrs:{"icon-f7":"menu","panel-open":"left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }